import {FC, useRef, useState} from "react";
import apiService from "../../services/api-service";
import {ParticipantAdminDto} from "../../types/contracts";
import QRCodeModal from "./AdminParticipantsQrModal";
import Pagination from "./Pagination";
import DownloadQRCode from "./QrCodeCardDownloader";
import EventSelectorComponent from "./EventSelectorComponent";
import ParticipantsTable from "./AdminParticipantsTableComponent";
import ParticipantModal from "./AdminParticipantsAdditionalServicesModal";
import {AdminParticipantsExportButton} from "./AdminParticipantsExportButton";
import {AdminParticipantsSearchInput} from "./AdminParticipantsSearchInput";
import {AdminPageCard} from "./AdminPageCard";
import {useEventsContext} from "../../providers/EventsProvider";
import {useOrganizationsAndParticipantsContext} from "../../providers/OrganizationsAndParticipantsProvider";

export const AdminParticipantsTable: FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalAdditionalServicesOpen, setIsModalAdditionalServicesOpen] =
      useState(false);
  const [selectedParticipant, setSelectedParticipant] =
      useState<ParticipantAdminDto | null>(null);
  const qrCodeRef = useRef<HTMLDivElement | null>(null);

  const loadEvents = useEventsContext()

  const {
    participants
  } = useOrganizationsAndParticipantsContext()

  const generateNewCode = async (participantId: string) => {
    await apiService.regenerateCode(participantId).then(() => {
      alert("Nový kód byl úspěšně vygenerován.");
    });
  };

  const openModal = (participant: ParticipantAdminDto) => {
    setSelectedParticipant(participant);
    setIsModalOpen(true);
  };

  const openAdditionalServicesModal = (participant: ParticipantAdminDto) => {
    setSelectedParticipant(participant);
    setIsModalAdditionalServicesOpen(true);
  };

  const closeModal = () => {
    setSelectedParticipant(null);
    setIsModalOpen(false);
  };
  const closeModalAdditionalServices = () => {
    setSelectedParticipant(null);
    setIsModalAdditionalServicesOpen(false);
  };

  return (
      <AdminPageCard title="Seznam účastníků">
          <div className="flex flex-col items-center">
            {/* Container for selectors */}
            <div className="w-full mb-2 flex flex-col md:flex-row justify-between items-center gap-3">
              <EventSelectorComponent
                  selectedValue={loadEvents.selectedEventId ?? ""}
                  onSelect={loadEvents.setSelectedEventId}
                  events={loadEvents.events || []}
                  isLoading={loadEvents.isLoading}
              />
              <AdminParticipantsSearchInput />
              {loadEvents.selectedEventId &&
                  <AdminParticipantsExportButton eventId={loadEvents.selectedEventId}/>
              }
            </div>

            {/* Container for the participants' table */}
            <div className="container overflow-x-auto">
              <ParticipantsTable
                  openModal={openModal}
                  openModalAdditionalServices={openAdditionalServicesModal}
                  generateNewCode={generateNewCode}
                  participants={participants}
                  events={loadEvents.events}
                  isLoading={loadEvents.isLoading}
                  selectedValue={loadEvents.selectedEventId ?? ""}
              />
            </div>

            {/* Pagination below the table */}
            {participants.length !== 0 && loadEvents.selectedEventId !== "" && (
                <div className="w-full mt-4">
                  <Pagination/>
                </div>
            )}
          </div>

        {/* Modal for QR code */}
        <QRCodeModal
            isOpen={isModalOpen}
            participant={selectedParticipant}
            onDownload={() => DownloadQRCode(qrCodeRef, selectedParticipant)}
            onClose={closeModal}
            qrCodeRef={qrCodeRef}
        />
        <ParticipantModal
            isOpen={isModalAdditionalServicesOpen}
            onClose={closeModalAdditionalServices}
            participant={selectedParticipant}
        />
      </AdminPageCard>
  );
};
